<template>
  <div class="body">
    <div class="title">
      帖子管理
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item>发布管理</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/tieziguanli' }">帖子管理</el-breadcrumb-item>
          <el-breadcrumb-item>查看详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <el-card class="padding">
      <el-col :span="12">
        <div class="fromdsadas">
          <div>
            <el-form class="demo-form-inline" :label-position="labelPosition" @submit.native.prevent>
              <el-form-item label="发布者" label-width="116px">
                  <div class="flexsaa">
                    <img :src="Query.facepic" alt="" class="imgs" :onerror="defaultImg">
                    {{Query.realname}}
                    <button class="huiyuanziliao" @click="openhuiyuan">会员资料</button>
                  </div>
              </el-form-item>
              <el-form-item label="发布板块" label-width="116px">
                {{Query.typename}}
              </el-form-item>
              <el-form-item label="发布标题" label-width="116px">
                {{Query.name}}
              </el-form-item>
              <el-form-item label="图片" label-width="116px">
                <div class="imgbox">
                  <div class="ssimg" v-for="(item, index) in Query.pics" :key="index">
                    <img :src="item.name" alt="" class="scsa">
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="描述" label-width="116px">
                {{Query.describe}}
              </el-form-item>
              <el-form-item label="物品状态" label-width="116px" v-if="Query.create_type === 1">
                {{Query.new_name}}
              </el-form-item>
              <el-form-item label="房源面积 " label-width="116px" v-if="Query.create_type === 5">
                {{Query.house_area}}
              </el-form-item>
              <el-form-item label="装修情况 " label-width="116px" v-if="Query.create_type === 5">
                {{Query.house_decoration}}
              </el-form-item>
              <el-form-item label="出售价格 " label-width="116px" v-if="Query.create_type === 5||1">
                {{Query.price}}
              </el-form-item>
              <el-form-item label="联系电话" label-width="116px">
                {{Query.mobile}}
              </el-form-item>
              <el-form-item label="发布时间" label-width="116px">
                {{Query.addtime}}
              </el-form-item>
              <el-form-item label="发布状态" label-width="116px">
                {{Query.is_status === 0?'下架':'上架'}}
              </el-form-item>
              <el-form-item label="置顶状态" label-width="116px">
                {{Query.is_top === 1?'置顶':'未置顶'}}
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="fromdsadas">
          <div>
            <el-form class="demo-form-inline" :label-position="labelPosition">
              <el-form-item label="类型" label-width="116px" v-if="Query.create_type === 2">
                {{Query.is_supply}}
              </el-form-item>
              <el-form-item label="公司名称" label-width="116px" v-if="Query.create_type === 6">
                {{Query.com_name}}
              </el-form-item>
              <el-form-item label="公司logo" label-width="116px" v-if="Query.create_type === 6">
                {{Query.com_logo}}
              </el-form-item>
              <el-form-item label="公司地址" label-width="116px" v-if="Query.create_type === 6">
                {{Query.city_name}}{{Query.area_name}}{{Query.address}}
              </el-form-item>
              <el-form-item label="薪资" label-width="116px" v-if="Query.create_type === 6">
                {{Query.com_staffsalary}}
              </el-form-item>
              <el-form-item label="联系电话" label-width="116px" v-if="Query.create_type === 6">
                {{Query.user_mobile}}
              </el-form-item>
              <el-form-item label="审核时间" label-width="116px" >
                {{Query.status_time}}
              </el-form-item>
              <el-form-item label="拒绝原因" label-width="116px" >
                {{Query.status_remark}}
              </el-form-item>

            </el-form>
          </div>
        </div>
      </el-col>
    </el-card>
    <vxe-modal width="579" ref="huiyuan" height="622" size="small" :show-footer="false" title="会员资料" :show-close="true">
      <div class="huiyuan">
        <el-form class="demo-form-inline" :label-position="labelPosition" style="margin-top: 60px; margin-left: 60px">
          <el-form-item label="头像" label-width="116px">
            <div class="flexsaa">
              <img :src="Query.facepic" alt="" class="imgs" :onerror="defaultImg">
            </div>
          </el-form-item>
          <el-form-item label="姓名" label-width="116px">
            <div class="flexsaa">
              {{Query.realname}}
            </div>
          </el-form-item>
          <el-form-item label="手机号码" label-width="116px">
            <div class="flexsaa">
              {{Query.mobile}}
            </div>
          </el-form-item>
          <el-form-item label="注册时间" label-width="116px">
            <div class="flexsaa">
              {{Query.user_regtime}}
            </div>
          </el-form-item>
          <el-form-item label="发帖数" label-width="116px">
            <div class="flexsaa">
              {{Query.user_postnum}}
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vxe-modal>
</div>
</template>

<script>
import { mapState } from 'vuex'
import { postView } from '@/api/tiezi'
export default {
  name: 'index',
  computed: {
    ...mapState(['fabuID']),
    defaultImg () {
      return 'this.src="' + require('../../assets/img/no.jpg') + '";'
    }
  },
  data () {
    return {
      labelPosition: 'left',
      Query: {}
    }
  },
  created () {
    this.xiangqing()
  },
  methods: {
    openhuiyuan () {
      this.$refs.huiyuan.open()
    },
    xiangqing () {
      const obj = {
        token: sessionStorage.getItem('token'),
        id: this.fabuID
      }
      postView(obj).then(({ data: res }) => {
        console.log('res', res)
        this.Query = res
      })
    }
  }
}
</script>

<style scoped lang="less">
.imgbox{
  width: 500px;
  display:flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  .ssimg{
    width: 90px;
    height: 90px;
    opacity: 1;
    background: rgba(0,0,0,0.00);
    border-radius: 50%;
    margin-right: 12px;
    .scsa{
      width: 100%;
      height: 100%;
    }
  }
}
.huiyuan{
  display: flex;
  flex-direction: column;
  //align-items: center;
  text-align: left;
}
.imgs{
  width: 90px;
  height: 90px;
  opacity: 1;
  background: rgba(0,0,0,0.00);
  border-radius: 50%;
  margin-right: 12px;
}
.padding{
  padding:40px 50px
}
.flexsaa{
  display: flex;
  flex-direction: row;
  align-items: center;
  .huiyuanziliao{
    margin-left: 13px;
    width: 78px;
    height: 37px;
    opacity: 1;
    border: 1px solid rgba(61,154,255,0.50);
    background: white;
    border-radius: 2px;
    opacity: 1;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #3d9aff;
    letter-spacing: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.body {
  display: flex;
  flex-direction: column;

  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }

    .dsadf {
      color: #3D9AFF;
    }
  }
}
</style>
